import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import * as _uniq from 'lodash/uniq';
import { AlertService } from '../../store/services/alert.service';
import { FirestoreService } from '../../shared/firestore/firestore.service';

@Component({
  selector: 'app-invite-project',
  templateUrl: './invite-project.component.html',
  styleUrls: ['./invite-project.component.sass']
})
export class InviteProjectComponent implements OnInit {
  @Input() projectId: string;
  @Input() project: any;
  @Input() opened: boolean;
  email: string;
  successAlertClosed = true;

  constructor(
    private alert: AlertService,
    private firestore: FirestoreService,
  ) {}

  ngOnInit() {
  }

  invite(emailForm, event: Event) {
    event.preventDefault();
    const storeProject = this.firestore.findProject(this.projectId);
    const users$ = this.firestore.usersbyEmail(this.email);
    Observable.zip(users$, storeProject.data$).do((data: any[]) => {
      const users = data[0];
      const project = data[1];
      if (users.length > 0) {
        const projectUserIds = project.userIds || [];
        projectUserIds.push(users[0].id);
        project.userIds = _uniq(projectUserIds);
      }
      storeProject.update(project);
      this.opened = false;
      this.alert.success('プロジェクトへ招待しました');
      return data[0];
    }).subscribe();
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/components/invite-project/invite-project.component.ts